<template>
  <div class="side-center-modal side-center-modal-add-editor">
    <div class="container-share-link-audience">
      <div class="share-link_title side-center_title">
        <aha-svg
          size="lg"
          v-if="isShowShareToEditList"
          name="arrow-tail"
          view-box="0 0 18 19"
          @click="isShowShareToEditList = false"
          class="flex-shrink-0 mr-3 align-middle cursor-pointer back-button"
        />
        {{ isShowShareToEditList ?
          $i18nPresenter.t('Invite team members') : $i18nPresenter.t('Invite to edit')
        }}
      </div>
      <ShareToEdit
        :hide-title="true"
        :presentation="presentation"
        v-if="isShowForPersonal && !isShowShareToEditList"
        @handleShowShareToEditList="showShareToEditModal()"
        @prepareDataForInviteTeamModal="prepareDataForInviteTeamModal"
      ></ShareToEdit>

      <ShareToEditList :presentation="presentation" v-if="isShowForPersonal && isShowShareToEditList" />

      <ShareToTeamForEditMain
        v-if="isShowForTeam"
        :presentation="presentation"
        :teamName="currentAccount.name"
      >
      </ShareToTeamForEditMain>
    </div>
  </div>
</template>
<script>

import { mapState } from 'vuex'
import constants from '@/constant'
import ShareToEdit from '@/components-v2/presentation-editor/collaboration/ShareToEdit.vue'
import ShareToEditList from '@/components-v2/modals/ShareToEditList.vue'
import ShareToTeamForEditMain from '@/components-v2/editor-share-v2/ShareToTeamForEditMain'

export default {
  name: 'SideCenterAddEditor',
  components: { ShareToTeamForEditMain, ShareToEditList, ShareToEdit },
  props: {
    presentation: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isShowShareToEditList: false,
    }
  },
  computed: {
    ...mapState({
      currentAccount: (state) => state.currentAccount,
      workingMode: (state) => state.workingMode,
    }),
    isShowForTeam() {
      return this.workingMode === constants.workspace.TEAM
    },
    isShowForPersonal() {
      return this.workingMode === constants.workspace.PERSONAL
    },
  },
  methods: {
    showShareToEditModal() {
      this.isShowShareToEditList = true
    },
    prepareDataForInviteTeamModal({ toBeInvitedMembers }) {
      this.$emit('prepareDataForInviteTeamModal', { toBeInvitedMembers })
    },
  },
}
</script>

<style scoped lang="scss">
.side-center-modal-add-editor {
  .side-center_title {
    font-size: 14px;
    font-weight: 700;
    line-height: 18px;
    letter-spacing: 0;
    text-align: left;
    color: rgba(0, 0, 0, 1);
    margin-bottom: 12px;
  }
}
</style>
